import React from 'react';
import { connect } from 'react-redux';
import { Table } from 'semantic-ui-react';
import { getExports, downloadExport } from '../../../data/analysis/layersDispatchers';

class Exports extends React.Component {
  componentDidMount() {
    const { dispatch, project } = this.props;
    dispatch(getExports(project.id));
  }

  render() {
    const { dispatch, exports } = this.props;

    exports
      .sort((a, b) => {
        if (a < b) return -1;
        if (b > a) return 1;
        return 0;
      })
      .reverse();

    const rows = exports.map(r => {
      const d = new Date(r.created_at);
      let link = <Table.Cell>{r.filename}</Table.Cell>;
      if (r.status === 'completed')
        link = (
          <Table.Cell>
            <button
              type="button"
              onClick={() => dispatch(downloadExport(r.project_id, r.id, r.filename))}
            >
              {r.filename}
            </button>
          </Table.Cell>
        );
      return (
        <Table.Row key={r.filename}>
          {link}
          <Table.Cell>{d.toLocaleString()}</Table.Cell>
          <Table.Cell>{r.status}</Table.Cell>
          <Table.Cell>{r.progress}</Table.Cell>
        </Table.Row>
      );
    });

    return (
      <div>
        <h2>Creating an export can take hours to proceed.</h2>
        <h2>Be sure to come back, refresh the page to see the evolution of the process</h2>
        <Table celled>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>filename</Table.HeaderCell>
              <Table.HeaderCell>created at</Table.HeaderCell>
              <Table.HeaderCell>status</Table.HeaderCell>
              <Table.HeaderCell>progress</Table.HeaderCell>
            </Table.Row>
          </Table.Header>

          <Table.Body>{rows}</Table.Body>
        </Table>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    project: state.projects.single.active,
    exports: state.analysis.single.exports
  };
};

export default connect(mapStateToProps)(Exports);



// WEBPACK FOOTER //
// ./src/scenes/analysis/components/analysis/visualisations/Exports.js